import {createReducer, on} from '@ngrx/store'
import {MenuState} from './menu.state'
import {removeMenu, setMenu} from './menu.action'

export const initialState: MenuState = {
    menu: null
}

export const menuReducer = createReducer(
    initialState,
    on(setMenu, (state, {menu}) => {
        return {...state, menu}
    }),
    on(removeMenu, (state) => {
        return {...state, menu: null}
    })
)
